export default __webpack_public_path__ + "static/media/monthlyBg.1b067b13.png";